import { useState } from 'react';
import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  .collapsible {
    display: grid;
    grid-template-rows: 0fr;
    opacity: 0;
    transition: all 0.2s ease-in-out;
  }

  .collapsible.open {
    opacity: 1;
    grid-template-rows: 1fr;
  }

  .collapsible-inner {
    overflow: hidden;
  }
`;

interface CollapsibleProps extends React.PropsWithChildren<React.ComponentProps<'div'>> {
  open: boolean;
}

export const Collapsible: React.FC<CollapsibleProps> = ({ children, open, ...props }) => {
  return (
    <>
      <GlobalStyle />
      <div className={`collapsible ${open ? 'open' : ''}`} {...props}>
        <div className="collapsible-inner">{children}</div>
      </div>
    </>
  );
};

export const useCollapsible = (initialState?: boolean) => {
  const [open, setOpen] = useState(initialState ?? false);
  const toggle = () => setOpen(!open);
  return { open, toggle, setOpen };
};
